import { iconConfig, SET_ICON_STYLE } from "../types";

const INITIAL_STATE = {
    styles: [],
    selected: null,
    manifest: null,
    baseUrl: null,
    error: null
};

export default (state = INITIAL_STATE, action) => {
    let { result, type } = action;

    switch (type) {
        case iconConfig.fetchSuccess:
            return {
                ...state,
                styles: result.styles,
                manifest: result.iconManifest,
                baseUrl: result.iconBaseUrl,
                status: "success"
            };

        case iconConfig.fetchError:
            return { ...state, error: result, status: "error" };

        case SET_ICON_STYLE:
            return { ...state, style: result };

        default:
            return state;
    }
};
